<app-compliance-nav [activeMenuItem]="'partnerWalletPendingInvites'"></app-compliance-nav>

<mat-progress-bar *ngIf="isLoadingPending" mode="indeterminate"></mat-progress-bar>
<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-h2">Pending Wallet Invites</mat-card-title>
  </mat-card-header>
  <mat-card-content>
  <table mat-table [dataSource]="pendingInvites" class="full-width">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> ID </th>
      <td mat-cell *matCellDef="let invite"> {{invite.id}} </td>
    </ng-container>

    <ng-container matColumnDef="wallet">
      <th mat-header-cell *matHeaderCellDef> Wallet </th>
      <td mat-cell *matCellDef="let invite"> {{invite.wallet?.walletNumber}} / {{ invite.wallet?.company?.name }}</td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Company </th>
      <td mat-cell *matCellDef="let invite"> {{invite.thirdPartyCompany?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="director">
      <th mat-header-cell *matHeaderCellDef> Director </th>
      <td mat-cell *matCellDef="let invite"> {{invite.applicant?.firstName}} {{invite.applicant?.lastName}} </td>
    </ng-container>

    <ng-container matColumnDef="view">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let invite"> <button mat-flat-button [routerLink]="invite.id"><mat-icon>edit</mat-icon></button> </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </mat-card-content>

</mat-card>
<mat-progress-bar *ngIf="isLoadingIncomplete" mode="indeterminate"></mat-progress-bar>
<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-h2">Incomplete Wallet Invites</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="incompleteInvites" class="full-width">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let invite"> {{invite.id}} </td>
      </ng-container>

      <ng-container matColumnDef="wallet">
        <th mat-header-cell *matHeaderCellDef> Wallet </th>
        <td mat-cell *matCellDef="let invite"> {{invite.wallet?.walletNumber}} / {{ invite.wallet?.company?.name }}</td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef> Company </th>
        <td mat-cell *matCellDef="let invite"> {{invite.thirdPartyCompany?.name}} </td>
      </ng-container>

      <ng-container matColumnDef="director">
        <th mat-header-cell *matHeaderCellDef> Director </th>
        <td mat-cell *matCellDef="let invite"> {{invite.applicant?.firstName}} {{invite.applicant?.lastName}} </td>
      </ng-container>

      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let invite"> <button mat-flat-button [routerLink]="invite.id"><mat-icon>edit</mat-icon></button> </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-card-content>

</mat-card>
<mat-progress-bar *ngIf="isLoadingFinished" mode="indeterminate"></mat-progress-bar>
<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-h2">Finished Wallet Invites</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="finishedInvites" class="full-width">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let invite"> {{invite.id}} </td>
      </ng-container>

      <ng-container matColumnDef="wallet">
        <th mat-header-cell *matHeaderCellDef> Wallet </th>
        <td mat-cell *matCellDef="let invite"> {{invite.wallet?.walletNumber}} / {{ invite.wallet?.company?.name }}</td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef> Company </th>
        <td mat-cell *matCellDef="let invite"> {{invite.thirdPartyCompany?.name}} </td>
      </ng-container>

      <ng-container matColumnDef="director">
        <th mat-header-cell *matHeaderCellDef> Director </th>
        <td mat-cell *matCellDef="let invite"> {{invite.applicant?.firstName}} {{invite.applicant?.lastName}} </td>
      </ng-container>

      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let invite"> <button mat-flat-button [routerLink]="invite.id"><mat-icon>edit</mat-icon></button> </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </mat-card-content>

</mat-card>
